import { render, staticRenderFns } from "./AnimationKillswitch.vue?vue&type=template&id=7060b809&"
import script from "./AnimationKillswitch.vue?vue&type=script&lang=js&"
export * from "./AnimationKillswitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports